import { IPlaceDetailsModalData } from './../../../../place-calendar/components/place.details.modal/place.details.modal.provider';
import { CreateEventComponent } from './../../../../event-calendar/components/create.event/create.event.component';
import { FancyEventDetailsModalComponent } from './../../../../event-calendar/components/event.details.modal/fancy.event.details.modal/fancy.event.details.modal.component';
import { IEventDetailsModalData } from './../../../../event-calendar/components/event.details.modal/event.details.modal.provider';
import { InfiniteScrollContainerComponent } from './../../infinite.scroll.container/infinite.scroll.container.component';
import { MediaQueryService } from 'src/app/common/services/media.query/media.query.service';
import { Component, ViewEncapsulation, OnInit, ViewChild, inject } from '@angular/core';
import { BaseComponent } from 'src/app/common/components/base.component';
import { bindFunctionsToThis, clone } from 'src/app/common/utils/object.extensions';
import { EMPTY, Observable, combineLatestWith, delay, of, switchMap, takeUntil } from 'rxjs';
import { VisitorEventService } from 'src/app/modules/event-calendar/services/visitor.event.service';
import { ActivatedRoute, Router } from '@angular/router';
import {
  CalendarActionCommand,
  CalendarQueryCommand,
} from '../../../models/calendar.action.command';
import { IInfiniteScrollLoadMoreEvent } from '../../infinite.scroll.container/infinite.scroll.container.component';
import { VisitorEvent } from '../../../models/visitor.event';
import { select, Store } from '@ngrx/store';
import { IAppState, IFrontendSettings } from '../../../ngrx.stores/frontend.settings/states';
import { eventQueryCommandSelector } from 'src/app/modules/event-calendar/ngrx.stores/event.query.command/selectors';
import { ModalService } from 'src/app/common/services/modal/modal.service';
import { frontendSettingsSelector } from 'src/app/modules/shared/ngrx.stores/frontend.settings/selectors';
import { routeConfigs } from 'src/app/common/constants/route.config';
import * as EventQueryCommandActions from 'src/app/modules/event-calendar/ngrx.stores/event.query.command/actions';
import * as PlaceQueryCommandActions from 'src/app/modules/place-calendar/ngrx.stores/place.query.command/actions';
import { VisitorPlaceService } from 'src/app/modules/event-calendar/services/visitor.place.service';
import { VisitorPlace } from '../../../models/visitor.place';
import { placeQueryCommandSelector } from 'src/app/modules/place-calendar/ngrx.stores/place.query.command/selectors';
import { CreatePlaceComponent } from 'src/app/modules/place-calendar/components/create.place/create.place.component';
import { FancyPlaceDetailsModalComponent } from 'src/app/modules/place-calendar/components/place.details.modal/fancy.place.details.modal/fancy.place.details.modal.component';
import { SeoService } from 'src/app/common/services/seo.service/seo.service';
import { ErrorAlertService } from 'src/app/common/services/error.alert/error.alert.service';
import { Location } from '@angular/common';
import { KeywordService } from '../../../services/keyword.service';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'ig-calendar',
  templateUrl: './visitor.calendar.component.html',
  styleUrls: ['./visitor.calendar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VisitorCalendarComponent extends BaseComponent implements OnInit {
  public placeDetailsId: string;
  public eventDetailsId: string;
  settings: IFrontendSettings;

  seoService = inject(SeoService);

  // this will be sent to infinite.scroll.container.component
  loadItems: IInfiniteScrollLoadMoreEvent = {
    loadMoreFn: this.getNextBatch.bind(this),
    isClearBeforeLoad: true,
  };
  actionCommand: CalendarActionCommand = new CalendarActionCommand();

  @ViewChild(InfiniteScrollContainerComponent, { static: false })
  container: InfiniteScrollContainerComponent;

  searchOptions = {
    name: true,
    address: false,
    category: false,
    description: false,
  };
  public searchFields: string[] = [];

  constructor(
    public activatedRoute: ActivatedRoute,
    public mediaQueryService: MediaQueryService,
    public visitorEventService: VisitorEventService,
    public visitorPlaceService: VisitorPlaceService,
    private _router: Router,
    private _location: Location,
    private _errorAlertService: ErrorAlertService,
    private _store: Store<IAppState>,
    private _modalService: ModalService,
    private _seoService: SeoService,
    private _keywordService: KeywordService
  ) {
    super({ activatedRoute });
    bindFunctionsToThis(this);

    this._store.pipe(select(frontendSettingsSelector)).subscribe((settings) => {
      settings && (this.settings = settings);
    });

    const eventCalendarPath = routeConfigs.visitor.eventCalendar;
    this.actionCommand.isEventCalendar = this._router.url.includes(`/${eventCalendarPath.path}`);
  }

  ngOnInit(): void {
    if (this.actionCommand.isEventCalendar) {
      this.setActionCommandForEvents();
      // this._seoService.addMetaForSEO(
      //   'Upcoming Events',
      //   'This is the upcoming events page'
      // );
    } else {
      this.setActionCommandForPlaces();
      // this._seoService.addMetaForSEO(
      //   'Local Places',
      //   'This is the city attractions and local business page'
      // );
    }
  }

  get isActive() {
    if (!this.settings) return true;

    return this.actionCommand.isEventCalendar
      ? this.settings.toggle.eventByGeolocation || this.settings.toggle.manualEvents
      : this.settings.toggle.placeCalendar;
  }

  setDefaultSortForPlaces() {
    const sort = this.frontendSettings?.customSettings.defaultPlaceSorting;
    if (sort) {
      this.actionCommand.queryCommand.defaultSort = sort;

      this.actionCommand.queryCommand.loadedIds =
        sort === 'random' ? VisitorPlaceService.loadedIds : undefined;

      if (sort === 'a-z') {
        this.actionCommand.queryCommand.alphabetically = 'asc';
      } else if (sort === 'z-a') {
        this.actionCommand.queryCommand.alphabetically = 'desc';
      }
    }
  }

  public getNextBatch(): Observable<VisitorEvent[] | VisitorPlace[]> {
    this.actionCommand.queryCommand.page++;
    if (this.actionCommand.isEventCalendar) {
      return this.visitorEventService.getEvents(this.hubName, this.actionCommand.queryCommand);
    } else {
      this.setDefaultSortForPlaces();
      return this.visitorPlaceService.getPlacesV3(this.hubName, this.actionCommand.queryCommand);
    }
  }

  public trackByIndex(i: number) {
    return i;
  }

  // show the event details modal if the url contains eventId
  public showEventDetailsIfHasEventIdInUrl() {
    this.eventDetailsId = this.allRouteParams['eventId'];
    this.processScriptSolution();

    if (this.eventDetailsId) {
      this._modalService.show<FancyEventDetailsModalComponent>({
        component: FancyEventDetailsModalComponent,
        data: {
          eventDetailsId: this.eventDetailsId,
        } as IEventDetailsModalData,
        panelClass: 'ig-modal-w-full',
      });
    }
  }

  // show the place details modal if the url contains placeId
  public showPlaceDetailsIfHasPlaceIdInUrl() {
    this.placeDetailsId = this.allRouteParams['placeId'];
    this.processScriptSolution();

    if (this.placeDetailsId) {
      this._modalService.show<FancyPlaceDetailsModalComponent>({
        component: FancyPlaceDetailsModalComponent,
        data: {
          placeDetailsId: this.placeDetailsId,
        } as IPlaceDetailsModalData,
        panelClass: 'ig-modal-w-full',
      });
    }
  }

  applySearchOptions(trigger: MatMenuTrigger) {
    this.searchFields = [];
    if (this.searchOptions.name) this.searchFields.push('name');
    if (this.searchOptions.address) this.searchFields.push('address');
    if (this.searchOptions.category) this.searchFields.push('category');
    if (this.searchOptions.description) this.searchFields.push('description');

    this.actionCommand.queryCommand.searchFields = this.searchFields.join(',');
    this.actionCommand.queryCommand.page = 1;
    trigger && trigger.closeMenu();

    this._store.dispatch(
      PlaceQueryCommandActions.setSearchText({
        search: this.actionCommand.queryCommand.search,
        searchFields: this.actionCommand.queryCommand.searchFields,
      })
    );
  }

  get isShowMoreSearchOptions(): boolean {
    return !this.actionCommand.isEventCalendar && !!this.actionCommand.queryCommand.search;
  }

  get hasSelectedOptions(): boolean {
    return (
      this.searchOptions.name ||
      this.searchOptions.address ||
      this.searchOptions.category ||
      this.searchOptions.description
    );
  }

  /** for clients who use the script solution (embed Imgoing script into their website)
   * these clients want to have a link to Imgoing event/place details page
   * so when an event/place details page is showing, we manually set the url to the Imgoing event/place details page
   * thus if we visit the link directly, it will check the URL and see if a event/place name + Id is specified (such as imgoing-event or imgoing-place), then go to the event/place details page after load
   */
  private processScriptSolution() {
    if (!window.location.search) return;

    this.processEntityId('imgoing-place', (id) => (this.placeDetailsId = id));
    this.processEntityId('imgoing-event', (id) => (this.eventDetailsId = id));
  }

  private processEntityId(paramName: string, setId: (id: string) => void): void {
    const nameId = new URLSearchParams(window.location.search).get(paramName);
    if (!nameId) return;

    const id = nameId.split('-').last();
    setId(id);
  }

  private setActionCommandForEvents() {
    // listen to event filter state (date, custom/fav events, search) changes and notify infinite.scroll.component to query events
    this._store
      .pipe(takeUntil(this.isDestroyed), select(eventQueryCommandSelector))
      .subscribe((cmd) => {
        
        const currentPath = this._location.path();        
        if (currentPath.includes('ig-custom-events=') && cmd.updateURL === false) return;

        this.actionCommand.queryCommand = clone(cmd);
        this.loadItems.isClearBeforeLoad = true;
        this.loadItems.isSearch = !!cmd.search; // hide promotional image when searching
        this.container?.offset.next(EMPTY);
      });

    this.showEventDetailsIfHasEventIdInUrl();

    this.visitorEventService
      .buildFilterEventsByDateCommandFromUrlQuery(this.activatedRoute)
      .subscribe((command: CalendarQueryCommand) => {
        command &&
          this._store.dispatch(
            EventQueryCommandActions.setDateRange({
              from: command.from,
              to: command.to,
              dateRange: command.dateRange,
            })
          );
      });

    this.visitorEventService
      .buildFilterEventsByCustomCategoryCommandFromUrlQuery(this.activatedRoute)
      .subscribe((command: CalendarQueryCommand) => {
        command &&
          this._store.dispatch(
            EventQueryCommandActions.setFavoriteEventBtnId({
              favBtnId: command.favoriteEventBtnId,
            })
          );
      });

    this.activatedRoute.firstChild?.url
      .pipe(
        combineLatestWith(this.activatedRoute.queryParams),
        switchMap(([url, queryParams]) => {
          return of({ url, queryParams });
        })
      )
      .subscribe(({ url, queryParams }) => {
        console.log('url', url);
        console.log('queryParams', queryParams);
        const path = url[0].path;

        // show submit event modal
        if (path === routeConfigs.visitor.eventCalendar.createEvent.path) {
          this._modalService.show<CreateEventComponent>({
            component: CreateEventComponent,
            panelClass: 'ig-modal-w-full',
          });
          return;
        }

        // show editor choice events
        if (path === routeConfigs.visitor.eventCalendar.editorChoice.path) {
          this._store.dispatch(
            EventQueryCommandActions.setIsChoice({
              choice: true,
            })
          );
        }

        // show favorite/custom events
        if (routeConfigs.visitor.eventCalendar.favEvent.path.startsWith(path)) {
          const btnId = this.allRouteParams['customEventBtnId'];
          this._store.dispatch(
            EventQueryCommandActions.setFavoriteEventBtnId({
              favBtnId: btnId,
              updateURL: false, // do not update url for the first time landing to a custom event page, as client may created a dedicated custom event page for it
            })
          );
        }

        // show location filtered events
        if (routeConfigs.visitor.eventCalendar.locationFilter.path.startsWith(path)) {
          const locationId = this.allRouteParams['locationId'];
          this._store.dispatch(
            EventQueryCommandActions.setLocation({
              // feedId: locationId,
              location: locationId,
            })
          );
        }

        // show group location filtered events
        if (routeConfigs.visitor.eventCalendar.groupLocationFilter.path.startsWith(path)) {
          const groupId = this.allRouteParams['groupId'];
          const group =
            this.frontendSettings.customSettings.customEventLocationFilterGroups.eventGroups.find(
              (x) => x._id.toString() === groupId
            );
          console.log('group', group);
          if (group && group.cities.length) {
            this._store.dispatch(
              EventQueryCommandActions.setLocationGroups({
                locations: group.cities,
              })
            );
          }
        }
      });
  }

  private setActionCommandForPlaces() {
    // listen to place filter state (custom/fav places, search) changes and notify infinite.scroll.component to query places
    this._store
      .pipe(takeUntil(this.isDestroyed), select(placeQueryCommandSelector))
      .subscribe((cmd) => {
        this.actionCommand.queryCommand = clone(cmd);
        if (cmd.search && cmd.searchFields) {
          this.searchOptions.name = cmd.searchFields.includes('name');
          this.searchOptions.address = cmd.searchFields.includes('address');
          this.searchOptions.category = cmd.searchFields.includes('category');
          this.searchOptions.description = cmd.searchFields.includes('description');
          this.searchFields = cmd.searchFields.split(',');
        }
        this.loadItems.isClearBeforeLoad = true;
        this.loadItems.isSearch = !!cmd.search; // hide promotional image when search
        this.container?.offset.next(EMPTY);
        this._keywordService.updateKeyword(cmd.search);
      });

    this.showPlaceDetailsIfHasPlaceIdInUrl();
    /**
     * if visit upcoming event from an event details page which was opened from a place details page, then show it in a new window (open process in UpcomingEventsComponent)
     to make it clear, the process is:
     1. visit a place details page
     2. click on the nearby events, then show the event details page in a new popup window, covers the first place details page popup
     3. if now click to visit another uncoming event from the previous event details page, show the new event details page in a new tab window
     4. the new event's nameId is added to the location href, so it need to check it from the href and open the event details page here
     *  */
    this.showEventDetailsIfHasEventIdInUrl();

    // to support the client site URL with custom categories (i.e. https://client.site.com/?ig-custom-places=xxx)
    this.visitorPlaceService
      .buildFilterPlacesByCustomCategoryCommandFromUrlQuery(
        this.activatedRoute,
        this.settings,
        this._router,
        this.allRouteParams
      )
      .subscribe((command: CalendarQueryCommand) => {
        command &&
          this._store.dispatch(
            PlaceQueryCommandActions.setCustomDefaultCategoryList({
              categoryList: command.categoryList,
              categoryName: command.categoryNode.title,
              categoryNode: command.categoryNode,
              locations: command.locations,
            })
          );
      });

    this.activatedRoute.firstChild?.url.subscribe((url) => {
      const path = url[0].path;
      console.log('path', path);

      // client can add ig-custom-places=xxx to their website URL to display specified categories, in this case we skip the following URL type check
      if (window.location.href.includes('ig-custom-places')) return;

      // show submit place modal
      if (path === routeConfigs.visitor.placeCalendar.createPlace.path) {
        this._modalService.show<CreatePlaceComponent>({
          component: CreatePlaceComponent,
          panelClass: 'ig-modal-w-full',
        });
        return;
      }

      // show ImGoing place default category
      if (routeConfigs.visitor.placeCalendar.category.path.startsWith(path)) {
        let category = this.allRouteParams['category'];
        category = this.visitorPlaceService.getDefaultCategoryName(category);
        this._store.dispatch(
          PlaceQueryCommandActions.setDefaultCategory({
            category,
            categoryName: category,
          })
        );
      }

      // show editor choice places
      if (path === routeConfigs.visitor.placeCalendar.editorChoice.path) {
        this._store.dispatch(
          PlaceQueryCommandActions.setIsChoice({
            choice: true,
          })
        );
      }

      // show favorite/custom places
      if (routeConfigs.visitor.placeCalendar.favCustomPlace.path.startsWith(path)) {
        const btnId = this.allRouteParams['favCustomPlaceBtnId'];
        this._store.dispatch(
          PlaceQueryCommandActions.setFavoritePlaceBtnId({
            favBtnId: btnId,
            hasFavoriteCategoryFromUrl: null,
            updateURL: false, // do not update url for the first time landing to a custom event page, as client may created a dedicated custom event page for it
          })
        );
      }

      // show location filtered places
      if (routeConfigs.visitor.placeCalendar.locationFilter.path.startsWith(path)) {
        const locationId = this.allRouteParams['locationId'];
        this._store.dispatch(
          PlaceQueryCommandActions.setLocation({
            location: locationId,
          })
        );
      }

      // show group location filtered places
      if (routeConfigs.visitor.placeCalendar.groupLocationFilter.path.startsWith(path)) {
        const groupId = this.allRouteParams['groupId'];
        const group =
          this.frontendSettings.customSettings.customPlaceLocationFilterGroups.placeGroups.find(
            (x) => x._id.toString() === groupId
          );
        console.log('group', group);
        if (group && group.cities.length) {
          this._store.dispatch(
            PlaceQueryCommandActions.setLocationGroups({
              locations: group.cities,
            })
          );
        }
      }

      // show custom default places
      if (routeConfigs.visitor.placeCalendar.customDefaultPlace.path.startsWith(path)) {
        const btnId = this.allRouteParams['categoryId'];
        let category = this.visitorPlaceService.findCategoryById(
          btnId,
          this.settings.customSettings.customDefaultPlaceCategory.customCategories
        );
        console.log('category', category);
        if (category) {
          let categoryList = [];
          this.visitorPlaceService.getAllSubCategories(category, categoryList);
          this._store.dispatch(
            PlaceQueryCommandActions.setCustomDefaultCategoryList({
              categoryList: categoryList,
              categoryName: category.title,
              categoryNode: category,
            })
          );
        }
      }
    });
  }
}
